import { proposalHref } from '../proposalHref';
/**
 * Get the URL path for a project based on its type.
 */ export function getProjectPath(project) {
    // pre_award routes to the general project view: the dedicated pre-award
    // workspace (/delivery/pre-award/:id) is keyed by the pangaea
    // pre_award_project id, not the zou projectId we have here. Phase 4a only
    // promoted the type tag + label; wiring the card to the workspace is a
    // separate id-mapping change (Phase 4b). See major-push/phase-4.md.
    //
    // contract also routes to the general project view: that's where documents
    // are uploaded/processed (ProjectFilesSection). The delivery program is
    // synced server-side from the processed docs and is keyed by a pangaea
    // program id we don't have here — the global processing tray links to it
    // once the batch completes.
    if (project.type === 'proposal') return proposalHref(project.projectId);
    const prefix = project.type === 'general' || project.type === 'pre_award' || project.type === 'contract' ? 'project' : project.type;
    return `/${prefix}/${project.projectId}`;
}
